import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/site-content").then((r) => setContent(r.data || {})).catch(() => setContent({}));
  }, []);

  return <SiteContext.Provider value={{ content }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext) || { content: null };
